import { createContext, useContext, useState, useEffect } from "react";

type Mode = "shia" | "sunni";

const PrayerModeContext = createContext<{
  mode: Mode;
  setMode: (m: Mode) => void;
} | null>(null);

export function PrayerModeProvider({ children }: { children: React.ReactNode }) {
  const [mode, setModeState] = useState<Mode>("shia");

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem("prayerMode") as Mode | null;
    if (saved === "shia" || saved === "sunni") setModeState(saved);
  }, []);

  // Update + persist
  const setMode = (m: Mode) => {
    setModeState(m);
    localStorage.setItem("prayerMode", m);
  };

  return (
    <PrayerModeContext.Provider value={{ mode, setMode }}>
      {children}
    </PrayerModeContext.Provider>
  );
}

export function usePrayerMode() {
  const ctx = useContext(PrayerModeContext);
  if (!ctx) throw new Error("usePrayerMode must be inside PrayerModeProvider");
  return ctx;
}
